import { render } from "./ActionRequiredCard.vue?vue&type=template&id=2fbecf4b&scoped=true"
import script from "./ActionRequiredCard.vue?vue&type=script&lang=js"
export * from "./ActionRequiredCard.vue?vue&type=script&lang=js"

import "@/assets/css/commandcenter/commandcenter.css?vue&type=style&index=0&id=2fbecf4b&scoped=true&lang=css&external"
import "./ActionRequiredCard.vue?vue&type=style&index=1&id=2fbecf4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbecf4b"]])

export default __exports__